import React from 'react';
import { UserContextProps } from '@interfaces/Contexts';

export const UserContext = React.createContext<UserContextProps>({} as UserContextProps);
